export default {
  translations: {
    welcome: 'Welcome!!',
    signInText: 'Sign in to continue.',
  },
}
